<template>
  <b-container fluid>
    <b-row class="p-3">
      <b-col md="12">
        <label for="kind-fleet">Fleet Category</label>
        <v-multiselect
          :multiple="true"
          track-by="id"
          placeholder="Select multiple"
          :options="fleetTypeOpt"
          label="name"
          value="id"
          id="kind-fleet"
          v-model="form.vehicle_type_ids"
        >
          <span slot="noResult"
            >Oops! No elements found. Consider changing the search query.</span
          >
        </v-multiselect>
      </b-col>
      <b-col md="12" class="d-flex flex-column mt-3">
        <label>Date</label>
        <date-picker
          class="w-100"
          type="year"
          v-model="form.year"
        ></date-picker>
      </b-col>
      <b-col md="12" class="d-flex flex-column my-3">
        <div class="w-100 bg-gray p-2 px-3 d-flex justify-content-between">
          <h5>Month</h5>
          <h5>Percentage</h5>
        </div>
      </b-col>
      <b-col md="12" class="d-flex flex-column mb-3">
        <div class="d-flex justify-content-between px-3">
          <label>Set same value each month</label>
          <b-form-checkbox
            switch
            size="md"
            v-model="form.is_same_input"
          ></b-form-checkbox>
        </div>
      </b-col>
      <b-col
        v-for="(item, index) in form.target_per_months"
        :key="index"
        md="12"
      >
        <b-row class="mx-3 px-0 py-2 border-bottom">
          <b-col lg="3">
            <label>Month {{ item.month }}</label>
          </b-col>
          <b-col lg="9">
            <b-input-group append="%">
              <b-form-input
                @input="handleChangeInput"
                type="number"
                v-model="item.percentage_target"
              ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="12" class="d-flex flex-column my-3">
        <b-col>
          <label>Remarks</label>
          <b-form-textarea
            id="textarea"
            v-model="form.remark"
            placeholder="Enter something..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-col>
      </b-col>
      <b-col md="12" class="d-flex justify-content-end my-3">
        <b-button variant="outline-primary" class="mr-2" outline @click="handleReset">
          Cancle and Close
        </b-button>
        <b-button v-if="!loading" variant="primary" @click="() => handleSubmit()" outline>
          Submit
        </b-button>
        <b-button v-else variant="primary" outline class="d-flex align-items-center px-3">
          <b-spinner small class="mr-2"></b-spinner>
          Loading...
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import moment from '@/node_modules/moment/moment'
import { fleetsActions, srActions } from '@/src/Utils/helper'

export default {
  name: 'ListTargetFleetAvailability',
  props: {
    showForm: Boolean,
  },
  data() {
    return {
      form: {
        vehicle_type_ids: [],
        year: moment().toDate(),
        target_per_months: [
          {
            month: 1,
            percentage_target: null,
          },
          {
            month: 2,
            percentage_target: null,
          },
          {
            month: 3,
            percentage_target: null,
          },
          {
            month: 4,
            percentage_target: null,
          },
          {
            month: 5,
            percentage_target: null,
          },
          {
            month: 6,
            percentage_target: null,
          },
          {
            month: 7,
            percentage_target: null,
          },
          {
            month: 8,
            percentage_target: null,
          },
          {
            month: 9,
            percentage_target: null,
          },
          {
            month: 10,
            percentage_target: null,
          },
          {
            month: 11,
            percentage_target: null,
          },
          {
            month: 12,
            percentage_target: null,
          },
        ],
        is_same_input: false,
        remark: '',
      },
      fleetTypeOpt: [],
      loading:false
    }
  },
  methods: {
    ...fleetsActions,
    ...srActions,
    async fetchFleetTypes() {
      try {
        const res = await this.getFleetTypes()
        this.fleetTypeOpt = res.data
      } catch (error) {
        console.log(error)
      }
    },
    async handleSubmit() {
      try {
        this.loading = true
        const newForm = {
          vehicle_type_ids: this.form.vehicle_type_ids.map((el) => el.id),
          year: moment(this.form.year).format('YYYY'),
          target_per_months: this.form.target_per_months.map((el) => ({
            ...el,
            remark: this.form.remark,
          })),
        }
        const res = await this.createTargetAvailabilities({ data: newForm })
        this.$swal({
          title: 'Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Success',
          type: 'error',
          text: 'Failed Create Data!',
          icon: 'error',
        })
      } finally {
        this.loading = false
        this.$emit('refetch')
      }
    },
    handleChangeInput(value) {
      if (this.form.is_same_input) {
        this.form.target_per_months.forEach((item) => {
          item.percentage_target = value
        })
      }
    },
    handleReset(){
      this.form.vehicle_type_ids =  [];
      this.form.year =  moment().toDate();
      this.form.remark =  '';
      this.form.target_per_months.forEach((el)=>{
        el.percentage_target = 0
      });
      this.$emit('refetch')
    },
  },
  mounted() {
    this.fetchFleetTypes()
  },
}
</script>
<style scoped>
.overflow-auto {
  overflow: auto !important;
}
.relative {
  position: relative;
}
.col-month {
  min-width: 160px;
}
.sticky {
  position: sticky !important;
}
.col-1 {
  left: 0px !important;
  z-index: 20;
  min-width: 40px;
}
.col-2 {
  left: 40px !important;
  z-index: 20;
  min-width: 200px;
  max-width: 200px;
}
.col-3 {
  left: 240px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
.col-4 {
  left: 340px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
.col-5 {
  left: 440px !important;
  z-index: 20;
  min-width: 100px;
  max-width: 100px;
}
</style>
